class LessonSsRepository {
  constructor(client) {
    this.storage = client.refFromURL(`${process.env.VUE_APP_FB_SS_BUCKET_URL}`)
  }

  async put(file, path) {
    const ref = this.storage.child(path)
    const snapshot = await ref.put(file)
    return await this.storage.child(path).getDownloadURL()
  }
}

export { LessonSsRepository }